import React from 'react'
import { Flex } from '@mprolab/uikit'
import MainWrapper from 'layouts/MainWrapper'
import { StyledBiennale } from 'components'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Image from 'components/CompatImage'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import PromoBanners, { PromoBannersType } from 'components/PromoBanners/PromoBanners'
import dottedBackground from '../../public/images/dottedBackgroundPattern1.webp'
import AutoStake from './AutoStake'
import ClassicStake from './ClassicStake'
import FeeVault from './FeeVault'

dayjs.extend(duration)

const StyledTitle = styled(StyledBiennale)`
  font-size: 32px;
  margin-bottom: 34px;

  ${({ theme }) => theme.mediaQueries.tablet} {
    font-size: 24px;
  }
`

const DottedBackgroundWrapper = styled(Flex)`
  position: absolute;
  top: -150px;
  left: 70px;
  width: 100%;
  height: 700px;
  z-index: -1;

  ${({ theme }) => theme.mediaQueries.tablet} {
    height: 550px;
    left: 0;
    left: 80px;
  }
`

const Stake: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <Flex pt="132px" justifyContent="center">
        <PromoBanners type={PromoBannersType.STAKE} />
      </Flex>
      <MainWrapper>
        <Flex fullWidth mt="32px" mb="234px" flexDirection="column">
          <StyledTitle>{t('stakingPanel.title')}</StyledTitle>
          <Flex flexDirection="column" gap="16px">
            {/* First, and permanent: it never expires, so it never moves down. */}
            <FeeVault />
            <ClassicStake />
            <AutoStake />
          </Flex>
        </Flex>
        <DottedBackgroundWrapper>
          <Image src={dottedBackground} objectFit="cover" loading="eager" />
        </DottedBackgroundWrapper>
      </MainWrapper>
    </>
  )
}

export default Stake
